import { Box, Icon, Stack, Typography } from "@tm/components"
import { ReactElement } from "react"

type Props = {
    iconName: string
    name: string
    children: ReactElement
}

export function OrderOptionContainer({ iconName, name, children }: Props) {
    return (
        <Stack gap={2}>
            <Box display="flex" alignItems="center">
                <Icon name={iconName} sx={{ marginRight: "1rem", height: "1.25em", width: "1.25em" }} />
                <Typography variant="h4">{name}</Typography>
            </Box>
            <Stack gap={2} pl="35px">
                {children}
            </Stack>
        </Stack>
    )
}
